import Cookies from 'js-cookie'
import { COOKIE_DOMAIN } from 'constants/environment'

export const removeCookie = (key: string) => {
  Cookies.remove(key, { path: '/', domain: COOKIE_DOMAIN })
}

export const getCookie = (key: string) => Cookies.get(key)
